import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Calendar, ArrowRight, Clock, User, Eye, BookOpen } from 'lucide-react';

const BlogPage = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.3 },
    transition: { duration: 0.35 }
  };

  const blogPosts = [
    {
      id: 1,
      slug: 'polished-concrete-trends-2026',
      title: 'Polished Concrete Trends 2026',
      excerpt: 'Polished concrete floors have evolved from a purely industrial solution to a mainstream design choice. In 2025, they\'re more popular than ever in homes, offices, and retail spaces across Sydney and Australia wide. Their combination of aesthetics, durability, and sustainability has captured the attention of designers and homeowners alike.',
      image: 'https://customer-assets.emergentagent.com/job_concretepro/artifacts/wqvbhtk9_HB_IMG-110.jpg',
      date: '07',
      month: 'Oct',
      year: '2025',
      readTime: '5 min read',
      category: 'Commercial',
      author: 'Sydney Concrete Polishers',
      featured: true,
      views: 71
    },
    {
      id: 2,
      slug: 'concrete-grinding-and-sealing',
      title: 'Concrete Grinding and Sealing: Durable, Stylish Floors Made Simple',
      excerpt: 'If you\'re looking for a tough, low-maintenance flooring solution that also looks great, concrete grinding and sealing might be exactly what you need. Whether you\'re renovating a home, upgrading your office, or finishing a retail space, this method delivers durability, style, and ease — without the high cost or hassle of traditional options.',
      image: 'https://customer-assets.emergentagent.com/job_concretepro/artifacts/mugq8d5n_1nb5hr7k_IMG-20250225-WA0092.jpg',
      date: '05',
      month: 'Sep',
      year: '2025',
      readTime: '6 min read',
      category: 'Residential',
      author: 'Sydney Concrete Polishers',
      featured: false,
      views: 98
    },
    {
      id: 3,
      slug: 'sydney-concrete-polishing',
      title: 'Sydney Concrete Polishing: What to Expect from Start to Finish',
      excerpt: 'There\'s growing demand for Sydney concrete polishing among those renovating homes or commercial spaces. Its sleek, low-maintenance finish, combined with long-term durability, makes it a go-to choice for anyone looking to upgrade tired concrete slabs into polished, high-performing surfaces.',
      image: 'https://customer-assets.emergentagent.com/job_concretepro/artifacts/47j3s8da_20211215_001559.jpg',
      date: '26',
      month: 'Aug',
      year: '2025',
      readTime: '7 min read',
      category: 'Education',
      author: 'Sydney Concrete Polishers',
      featured: true,
      views: 157
    },
    {
      id: 4,
      slug: 'benefits-of-polished-concrete-flooring-sydney',
      title: 'Polished Concrete Flooring Sydney – Top 7 Benefits for Homeowners and Businesses',
      excerpt: 'Polished concrete floors Sydney property owners love this modern flooring solution as it is becoming one of the most practical and attractive flooring finishes available today. Whether you\'re upgrading your home or improving your business space, polished concrete flooring delivers impressive benefits that go beyond just appearance.',
      image: 'https://customer-assets.emergentagent.com/job_concretepro/artifacts/c7adcj0f_20240211_160715.jpg',
      date: '18',
      month: 'Aug',
      year: '2025',
      readTime: '8 min read',
      category: 'Residential',
      author: 'Sydney Concrete Polishers',
      featured: true,
      views: 142
    },
    {
      id: 5,
      slug: 'sydney-polished-concrete-specialists',
      title: 'Sydney Polished Concrete Specialists- Quality Flooring for Modern Spaces',
      excerpt: 'Polished concrete floors in Sydney homes are becoming the go-to solution for modern-looking spaces, and the service is great for practical living. Whether you\'re a homeowner updating your space or a builder looking for reliable finishes, polished concrete offers the durability and clean aesthetic with a classy touch that fits in today\'s lifestyle.',
      image: 'https://customer-assets.emergentagent.com/job_concretepro/artifacts/pe93zrcc_maxresdefault.jpg',
      date: '11',
      month: 'Aug',
      year: '2025',
      readTime: '6 min read',
      category: 'Commercial',
      author: 'Sydney Concrete Polishers',
      featured: false,
      views: 150
    },
    {
      id: 6,
      slug: 'polished-concrete-floors',
      title: 'Polished Concrete Floors Sydney: A Stylish Choice for Modern Living',
      excerpt: 'If you\'re planning a home renovation or designing a brand-new space, polished concrete floors Sydney residents trust are the perfect choice for modern living. These floors combine elegance, durability, and ease of maintenance — all in one sleek finish. More and more homeowners, builders, and architects across Sydney are embracing this flooring solution.',
      image: 'https://customer-assets.emergentagent.com/job_concretepro/artifacts/ldhk1u22_IMG-20260329-WA0073.jpg',
      date: '26',
      month: 'Jul',
      year: '2025',
      readTime: '7 min read',
      category: 'Residential',
      author: 'Sydney Concrete Polishers',
      featured: true,
      views: 171
    },
    {
      id: 7,
      slug: 'benefits-of-polished-concrete-floors',
      title: 'Top 5 Benefits of Polished Concrete Floors in 2025',
      excerpt: 'Polished concrete is not just a flooring option; it\'s a revelation in the world of interior design and functionality. If you\'re considering flooring solutions for your space, delve into the brilliance of polished concrete. With its unmatched durability, aesthetic appeal, and versatility, polished concrete stands as a testament to innovation.',
      image: 'https://customer-assets.emergentagent.com/job_concretepro/artifacts/ry4jdnnu_20250810_141512.jpg',
      date: '11',
      month: 'May',
      year: '2025',
      readTime: '8 min read',
      category: 'Education',
      author: 'Sydney Concrete Polishers',
      featured: false,
      views: 286
    },
    {
      id: 8,
      slug: 'polished-concrete-floors-in-sydney',
      title: 'Polished Concrete Floors in Sydney',
      excerpt: 'In the bustling business landscape of Sydney, where style and functionality converge, polished concrete floors emerge as a transformative force for commercial spaces. The gleaming allure of polished concrete is reshaping the way businesses approach their interiors, offering a game-changing solution that marries aesthetics with durability.',
      image: 'https://customer-assets.emergentagent.com/job_concretepro/artifacts/ldhk1u22_IMG-20260329-WA0073.jpg',
      date: '18',
      month: 'Oct',
      year: '2024',
      readTime: '9 min read',
      category: 'Residential',
      author: 'Sydney Concrete Polishers',
      featured: false,
      views: 434
    }
  ];

  const filteredPosts = blogPosts;

  const featuredPost = blogPosts.find(post => post.featured);

  return (
    <div className="min-h-screen pt-16" data-testid="blog-page">
      {/* Hero */}
      <section className="section-spacing bg-gradient-to-br from-slate-100 via-slate-50 to-slate-100 dark:from-slate-800 dark:via-slate-900 dark:to-slate-800">
        <div className="container mx-auto px-4 text-center">
          <motion.div {...fadeInUp}>
            <BookOpen className="w-16 h-16 text-slate-600 dark:text-slate-300 mx-auto mb-6" />
            <h1 className="text-4xl md:text-6xl font-bold mb-6 text-slate-800 dark:text-slate-100">
              Blog & 
              <span className="bg-gradient-to-r from-amber-600 to-orange-600 bg-clip-text text-transparent block">
                Insights
              </span>
            </h1>
            <p className="text-lg text-slate-600 dark:text-slate-300 max-w-3xl mx-auto">
              Expert insights, industry knowledge, and practical guides from Sydney's concrete polishing specialists
            </p>
          </motion.div>
        </div>
      </section>

      {/* Blog Section */}
      <section className="section-spacing bg-background">
        <div className="container mx-auto px-4">
      {/* Simple Blog Grid */}
      <section className="py-8 bg-background">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-6 text-slate-800 dark:text-slate-100">
            Latest Blog Posts
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredPosts.map((post, index) => (
              <div key={post.id} className="bg-white dark:bg-slate-800 rounded-lg shadow-lg overflow-hidden">
                <div className="relative">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-48 object-cover"
                  />
                  {/* Date badge */}
                  <div className="absolute top-3 right-3 w-12 h-12 bg-white dark:bg-slate-900 rounded-full shadow-lg flex flex-col items-center justify-center">
                    <span className="text-sm font-bold text-slate-800 dark:text-slate-100">
                      {post.date}
                    </span>
                    <span className="text-xs text-slate-600 dark:text-slate-300">
                      {post.month}
                    </span>
                  </div>
                  {/* Category badge */}
                  <div className="absolute top-3 left-3">
                    <span className="bg-slate-900/80 text-white px-2 py-1 text-xs rounded">
                      {post.category}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-bold text-lg mb-2 text-slate-800 dark:text-slate-100 hover:text-amber-600 cursor-pointer transition-colors">
                    <a href={`https://sydneyconcretepolishers.com.au/${post.slug}/`} target="_blank" rel="noopener noreferrer">
                      {post.title}
                    </a>
                  </h3>
                  <p className="text-slate-600 dark:text-slate-300 text-sm mb-3 line-clamp-3">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs text-slate-500 dark:text-slate-400">
                    <span>{post.readTime}</span>
                    <span>{post.views} views</span>
                  </div>
                  <a 
                    href={`https://sydneyconcretepolishers.com.au/${post.slug}/`} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-block mt-3 bg-amber-600 text-white px-4 py-2 rounded-lg hover:bg-amber-700 transition-colors text-sm"
                  >
                    Read Full Article
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className="section-spacing bg-slate-50 dark:bg-slate-900">
        <div className="container mx-auto px-4">
          <motion.div {...fadeInUp}>
            <Card className="bg-gradient-to-r from-slate-900 to-slate-800 dark:from-slate-100 dark:to-slate-200 text-white dark:text-slate-900 border-0 shadow-2xl">
              <CardContent className="p-12 text-center">
                <BookOpen className="w-16 h-16 mx-auto mb-6 text-amber-400 dark:text-amber-600" />
                <h2 className="text-3xl font-bold mb-4">Stay Informed with Expert Insights</h2>
                <p className="mb-8 max-w-2xl mx-auto opacity-90 leading-relaxed">
                  Subscribe to our newsletter for the latest concrete polishing tips, project showcases, 
                  industry trends, and exclusive insights from our expert team.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
                  <input
                    type="email"
                    placeholder="Enter your email address"
                    className="flex-1 h-12 px-6 rounded-lg border-0 bg-white/90 dark:bg-slate-800 text-slate-800 dark:text-slate-100 text-sm shadow-lg"
                    data-testid="newsletter-email-input"
                  />
                  <Button 
                    className="bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-white border-0 px-8"
                    data-testid="newsletter-subscribe-btn"
                  >
                    Subscribe
                  </Button>
                </div>
              </CardContent>
            </Card>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
